import React, { useEffect, useState, useRef } from "react";
import { dateFormat } from "../../services/Util";
import Constants from "../../Constants";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import ProjectLanguageDetail from "./ProjectLanguageDetail";
import { RotatingLines } from "react-loader-spinner";
import $ from 'jquery';
import { handleError } from "../../services/authApiRoutes/APImethods";

export default function ProjectDetailModal(prop) {
  
  function hideRightModel() {
    const isStatusClicked = $('.focusStatus').length;
    setLanguages([]);
    document.body.classList.remove("modal-open");
    if (isStatusClicked) {
      $('.focusStatus').trigger('focus');
      $('.focusStatus').removeClass('focusStatus');
    } else {
      $('#row-'+rowId+' a').trigger('focus');
    }
  }
  const escapeModal = (event) => {
    const isStatusClicked = $('.focusStatus').length;
    const elem = $('.campaign-right-modal > div:not(:first-child):last');
    const elemList = $('.uploaded-doc-list li.flex-center:last button:last');
    const isDataLoading = $(event.target).next().find('.dataLoading').length > 0;
    const isNextElementHidden = $(event.target).next().hasClass('hide');
    const isDataStillLoading = $(event.target).next().find('.noData').length > 0;
    const isDataNotAvaliable = $(event.target).next().find('.langDetails').length > 0;
    const isOnCloseBtn = $(event.target).is($('#close-popup'));
    if(event.key === Constants.TAB && !event.shiftKey) {
        if(!$('.language-block').length ||
        $(event.target).is(elemList) && elem.has($(event.target)).length > 0 ||
        $(event.target).is(elem.find('.language-block')) && elem.find('.language-block').attr('aria-expanded')==='false' ||
        isDataLoading && !isNextElementHidden && $(event.target).is(elem.find('.language-block')) ||
        isDataStillLoading && $(event.target).is(elem.find('.language-block')) ||
        isDataNotAvaliable && !$('.uploaded-doc-list').length && $(event.target).is(elem.find('.language-block'))
        ){
          event.preventDefault();
          $('#close-popup').trigger('focus');
        }
    } else if (event.key === Constants.TAB && event.shiftKey) {
        if(!$('.language-block').length){
          event.preventDefault();
          $('#close-popup').trigger('focus');
        } else if(isOnCloseBtn && $('.uploaded-doc-list').length && elem.find('.language-block').attr('aria-expanded')==='true'){
          event.preventDefault();
          elemList.trigger('focus');
        } else if(isOnCloseBtn && elem.find('.language-block').attr('aria-expanded')==='false' ||
        elem.find('.langDetails').length > 0 && !$('.uploaded-doc-list').length && isOnCloseBtn ||
        elem.find('.dataLoading').length > 0 && isOnCloseBtn){
          event.preventDefault();
          elem.find('.language-block').trigger('focus');
        }
    } else if (event.key == Constants.ESCAPE ) {
        document.body.classList.remove("modal-open");
        if (isStatusClicked) {
          $('.focusStatus').trigger('focus');
          $('.focusStatus').removeClass('focusStatus');
        } else {
          $('#row-'+rowId+' a').trigger('focus');
        }
    }
  }

  const firstFocus = useRef(null)
  const [langDetailLoaded, setLoader] = useState(true);
  const [languageAssociated, setLanguages] = useState([]);
  const rowId = prop?.row_detail?.resource?.projectResource?.id;
  useEffect(() => {
    firstFocus.current.focus()
    setLoader(true);
    if(prop?.row_detail?.resource?.projectResource?.id !== undefined){getAxiosResponse(
      APIUrls.PROJECT_DELIVERABLE_STATUS(prop?.row_detail?.resource?.projectResource.id)
    ).then((res) => {
        if (res.data !== "") {
          setLanguages(res.data.data);
          setLoader(false);
          setTimeout(() => {
            $('.progressReport').removeAttr('tabindex');
          }, 300);
        }
      })
      .catch((err) => {
        handleError(err);
      })}
  }, [prop]);
  return (
    <div className="right-modal campaign-right-modal" aria-labelledby="campProjectName" aria-modal="true" role="dialog"
    onKeyDown={(e)=>escapeModal(e)}
    >
      <div className="modal-header flex">
        <div className="left flex-center">
          <strong id="campProjectName">{prop.row_detail?.resource?.projectResource?.name}</strong>
        </div>
        <button
          className="close flex-center"
          aria-label="close"
          id='close-popup'
          onClick={hideRightModel}
          ref={firstFocus}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
              fill="white"
            />
            <path
              d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
              fill="white"
            />
          </svg>
        </button>
      </div>

      {langDetailLoaded ? (
        <div style={{ textAlign: "center" }}>
          <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            width="96"
            visible={langDetailLoaded}
          />
        </div>
      ) : (
        languageAssociated.length !== 0 ? 
        languageAssociated.map((language, key) => {
          return (
            <div key={key}>
              <ProjectLanguageDetail
                language_detail={language}
                project_id={prop.row_detail.resource?.projectResource.id}
              />
            </div>
          );
        }) : 
        <div className="no-data-display align-center">
          <i className="nodata-icon"></i>
          <p>{Constants.NO_DATA_FOUND}</p>
        </div>
      )}
    </div>
  );
}